// extracted by mini-css-extract-plugin
export default {"dropzone":"UploadFile_dropzone__t7gdN","dropzoneActive":"UploadFile_dropzoneActive__J42Jp","boxFormat":"UploadFile_boxFormat__ZRLn+"};